import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';

const TextInput = ({ input, meta: { touched, error }, ...custom }) => (
  <FormControl required={custom.required} fullWidth={custom.fullWidth}>
    <InputLabel htmlFor={custom.name}>{custom.label}</InputLabel>
    <Input
      type={custom.type || 'text'}
      id={custom.name}
      autoFocus={custom.autoFocus}
      {...input}
      {...custom}
    />
    {touched &&
      error && (
        <FormHelperText error id={`${custom.name}-error`}>
          {error}
        </FormHelperText>
      )}
  </FormControl>
);

export default TextInput;
